import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import PopoverMenu from '@t7x000/apex-web/lib/components/common/PopoverMenu/PopoverMenu';
import Spinner from '@t7x000/apex-web/lib/components/common/Spinner/Spinner';
import { getBEMClasses } from '@t7x000/apex-web/lib/helpers/cssClassesHelper';

import './AccountsDropdownComponent.css';

class AccountsDropdown extends React.Component {
  static propTypes = {
    selectedAccount: PropTypes.shape({
      AccountName: PropTypes.string.isRequired,
    }),
    accounts: PropTypes.array.isRequired,
    logout: PropTypes.func.isRequired,
    history: PropTypes.object,
    settingsRoute: PropTypes.string,
    activityRoute: PropTypes.string,
    betaOptedIn: PropTypes.string,
    showSelectedAccount: PropTypes.bool,
  };

  static defaultProps = {
    settingsRoute: '',
  };

  selectAccount = (account) => {
    if (location.pathname.startsWith('/trade')) {
      let route = '/trade/spot'; // default

      if (account.AccountType === 'Margin') {
        route = '/trade/margin';
      } else if (account.AccountType === 'Futures') {
        route = '/trade/futures';
      }
      this.props.history.push(route);
    }

    this.props.selectAccount(account.AccountId, account.OMSID);
  };

  renderMenuItems = () => {
    const { accounts, selectedAccount, customClass } = this.props;
    const bemClasses = getBEMClasses(['accounts-dropdown', customClass]);

    let menuItems;
    if (accounts.length <= 1) {
      menuItems = [
        {
          label: selectedAccount.AccountName,
          customClass: bemClasses('username-in-dropdown'),
        },
      ];
    } else {
      menuItems = [
        ...accounts
          .filter((account) => this.props.showSelectedAccount || account.AccountId !== selectedAccount.AccountId)
          .sort((a, b) => {
            // Define sort order: Unknown/Spot -> Asset -> Margin -> Futures
            const order = { Asset: 1, Margin: 2, Futures: 3 };
            const aOrder = order[a.AccountType] || 0; // Unknown types go first (assumed spot)
            const bOrder = order[b.AccountType] || 0;
            return aOrder - bOrder;
          })
          .map((account) => {
            const label = this.formatAccountName(account);

            const item = {
              label,
              onClick: () => this.selectAccount(account),
            };

            if (selectedAccount.AccountId === account.AccountId) {
              item.customClass = 'selected';
            }

            return item;
          }),
      ];
    }

    return menuItems;
  };

  formatAccountName = (account) => {
    if (!account || !account.AccountName) return '';

    const { t, tradingAccountId, retirementAccountId } = this.props;

    // if (account.AccountName.length > 5) {
    //   const truncated = account.AccountName.substring(0, 5) + '...';
    //   const accountType = account.AccountType === 'Asset' ? 'Spot' : account.AccountType;
    //   return truncated + accountType;
    // }

    if (account.AccountId === tradingAccountId) {
      return t('Trading Account');
    }

    if (account.AccountId === retirementAccountId) {
      return t('Retirement Account');
    }

    return account.AccountName;
  };

  render() {
    const { selectedAccount, customClass, t } = this.props;
    const bemClasses = getBEMClasses(['user-summary', customClass]);

    const displayAccountName = this.formatAccountName(selectedAccount);

    return (
      <div className={bemClasses('container')} data-account-switcher="true">
        {['page-dashboard', 'page-wallet', 'page-activity'].includes(customClass) && (
          <div className={bemClasses('label')}>{t('Account')}</div>
        )}
        {selectedAccount ? (
          <PopoverMenu
            customClass={bemClasses()}
            popoverProps={{
              trigger: (props) => (
                <button
                  type="button"
                  className={bemClasses('popover-menu-trigger')}
                  aria-label={t('Switch account')}
                  {...props}>
                  <div className={bemClasses('user-info-container')}>
                    <span className={bemClasses('username-in-display')} title={selectedAccount.AccountName}>
                      {displayAccountName}
                    </span>

                    <span className={bemClasses('popover-menu-trigger-triangle')} />
                  </div>
                </button>
              ),
              customClass: 'accounts-dropdown',
            }}
            items={this.renderMenuItems()}
          />
        ) : (
          <Spinner isInline customClass={bemClasses} />
        )}
      </div>
    );
  }
}

export default withTranslation()(AccountsDropdown);
